export const SLICE_SECTIONS = {
  WATERMARK: 'watermarkSettings',
  MODALS: 'modals',
  LOADING: 'loading',
};

export const STORE_KEYS = {
  BUSINESS_NAME: 'businessName',
  TIME_ZONE: 'timezone',
  TIME_ZONE_LIST: 'timezonesList',
  LANGUAGE: 'language',
  LOGO: 'logoUrl',
  WEB_PROPERTY_URL: 'webPropertyUrl',
  DEV_PROPERTY_URL: 'devPropertyUrl',
  SHOW_OTHER_AGENTS_CONTACTS: 'showContactsEvents',
  SHOW_NEWS_FROM: 'showOnlyFromBranch',
  FOOTER_TEXT: 'portalFooterDescription',
  SMTP: 'smtp',
  PORT: 'port',
  WATERMARK_ENABLED: 'watermarkEnabled',
  COMPANY_ID: 'companyId',
  API_KEY: 'apiKey',
  SHOW_INTERNAL_INFO_IN_API: 'showInternalInfoInApi',
  SHOW_NOT_AVAILABLE_IN_API: 'showNotAvailableInApi',
  LEGAL_CHECK_REQUIRED: 'legalCheckRequired',
  PUBLISH_WITHOUT_LEGAL_CHECK: 'publishWithoutLegalCheck',
  LEGAL_CHECK_BASE_TEXT: 'legalCheckBaseText',
  MODAL_EDITION: 'editionOpen',
  MODAL_CONFIRM: 'confirmOpen',
  LOGO_LOADING: 'logoUpload',
  WATERMARK_LOGO_LOADING: 'watermarkLogoUpload',
  WATERMARK_SETTINGS_LOADING: 'applyWatermarkSettings',
  REGENERATE_API_KEY_LOADING: 'regenerateApiKey',
};

export const WATERMARK_STORE_KEYS = {
  HAS_SETTINGS: 'hasSettings',
  WATERMARK_LOGO_URL: 'watermarkLogoUrl',
  OPACITY: 'opacity',
  SIZE: 'size',
  POSITION: 'position',
  TYPE: 'type',
  MARGIN_PX: 'marginPx',
  PREVIEW: 'preview',
  NEW_LOGO_FILE: 'newLogoFile',
};

export const BACK_KEYS = {
  businessName: 'name',
  timezone: 'timezone',
  language: 'language',
  webPropertyUrl: 'web_property_url',
  devPropertyUrl: 'web_development_url',
  showContactsEvents: 'show_contact_events_in_news',
  showOnlyFromBranch: 'show_only_news_from_branch',
  portalFooterDescription: 'portal_footer',
  smtp: 'email_smtp_host',
  port: 'email_smtp_port',
  modalOpen: 'modal_open',
  watermarkEnabled: 'use_watermark',
  logoUrl: 'logo',
  watermarkLogoUrl: 'watermark',
  companyId: 'company_id',
  apiKey: 'api_key',
  showInternalInfoInApi: 'show_owner_in_api',
  showNotAvailableInApi: 'show_not_available_properties_in_api',
  legalCheckRequired: 'property_legal_check',
  publishWithoutLegalCheck: 'property_portal_without_legal_check',
  legalCheckBaseText: 'property_legal_check_base_text',
};

export const BACK_WATERMARK_KEYS = {
  watermarkLogoUrl: 'logo',
  opacity: 'opacity',
  size: 'size',
  position: 'position',
  type: 'mode',
  marginPx: 'margin_px',
};

// Watermark editor related constants

export const WATERMARK_PREVIEW = {
  PORTRAIT: 'portrait',
  LANDSCAPE: 'landscape',
  SQUARE: 'square',
};

export const WATERMARK_POSITIONS = {
  TOP_LEFT: 'top_left',
  TOP_RIGHT: 'top_right',
  TOP: 'top',
  CENTER: 'center',
  BOTTOM_LEFT: 'bottom_left',
  BOTTOM: 'bottom',
  BOTTOM_RIGHT: 'bottom_right',
};

export const WATERMARK_OPACITIES = {
  HIGH: 30,
  MEDIUM: 60,
  LOW: 100,
};
export const WATERMARK_TYPE = {
  SINGLE: 'single',
  DOUBLE: 'double',
};
export const WATERMARK_SIZE = {
  SMALL: 'small',
  LARGE: 'large',
};

export const WATERMARK_SIZES = {
  small: { width: '20%', height: '20%' },
  large: { width: '30%', height: '35%' },
};

export const OPTIONS_TRANSLATION_KEYS = {
  TYPE: {
    single: 'Single',
    double: 'Double',
  },
  POSITION: {
    top_left: 'Top - left',
    top_right: 'Top - right',
    top: 'Top',
    center: 'Center',
    bottom_left: 'Bottom - left',
    bottom: 'Bottom',
    bottom_right: 'Bottom - right',
  },
  SIZE: {
    small: 'Small',
    large: 'Large',
  },
  PREVIEW: {
    portrait: 'Portrait',
    landscape: 'Landscape',
    square: 'Square',
  },
};

const { TOP_LEFT, TOP_RIGHT, CENTER, BOTTOM_LEFT, BOTTOM_RIGHT, TOP, BOTTOM } =
  WATERMARK_POSITIONS;
const { SINGLE, DOUBLE } = WATERMARK_TYPE;
const { HIGH, MEDIUM, LOW } = WATERMARK_OPACITIES;
const { SMALL, LARGE } = WATERMARK_SIZE;
const { LANDSCAPE, PORTRAIT, SQUARE } = WATERMARK_PREVIEW;

export const WATERMARK_POSITIONS_LIST = [
  TOP_LEFT,
  TOP,
  TOP_RIGHT,
  null,
  CENTER,
  null,
  BOTTOM_LEFT,
  BOTTOM,
  BOTTOM_RIGHT,
];

export const WATERMARK_TYPES_LIST = [SINGLE, DOUBLE];

export const WATERMARK_OPACITIES_LIST = [HIGH, MEDIUM, LOW];

export const WATERMARK_SIZES_LIST = [SMALL, LARGE];

export const WATERMARK_PREVIEW_LIST = [LANDSCAPE, PORTRAIT, SQUARE];

export const EMPTY_LOGO_URLS = ['empty-logo', 'nologo'];

export const API_KEY_HELP_URL =
  'https://dudas.tokkobroker.com/es/articles/432304-como-saber-cual-es-la-api-key-de-mi-cuenta';
